import { render, staticRenderFns } from "./ReferralShareOrderSelector.vue?vue&type=template&id=5265c343&"
import script from "./ReferralShareOrderSelector.vue?vue&type=script&lang=ts&"
export * from "./ReferralShareOrderSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralShareOrderSelector.vue?vue&type=style&index=0&id=5265c343&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports